// extracted by mini-css-extract-plugin
export default {"sortingGroup":"styles-module__sortingGroup--FVPsx","label":"styles-module__label--jEyNa"};